import { API } from "@/lib/api";

export const WS_STATUS = {
  planifie: { label: "Planifié", cls: "bg-slate-100 text-slate-600 border-slate-200", dot: "bg-slate-400" },
  en_cours: { label: "En cours", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500" },
  en_pause: { label: "En pause", cls: "bg-amber-50 text-amber-700 border-amber-200", dot: "bg-amber-500" },
  termine: { label: "Terminé", cls: "bg-blue-50 text-blue-700 border-blue-200", dot: "bg-blue-500" },
  annule: { label: "Annulé", cls: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-500" },
};

export const STEP_STATUS = {
  a_faire: { label: "À faire", cls: "bg-slate-100 text-slate-600" },
  en_cours: { label: "En cours", cls: "bg-amber-50 text-amber-700" },
  terminee: { label: "Terminée", cls: "bg-emerald-50 text-emerald-700" },
  non_realisee: { label: "Non réalisée", cls: "bg-rose-50 text-rose-700" },
};

export const REQUEST_STATUS = {
  nouvelle: "Nouvelle", en_traitement: "En cours de traitement",
  attente_client: "En attente du client", cloturee: "Clôturée",
};

// Portail client : session séparée du token utilisateur interne.
export const PORTAL_KEY = "signa_portal_session";
export function portalFileUrl(fid) {
  return `${API}/track/portal/file/${fid}`;
}
